<template>
  <div>
    <p class="xPadding titleModal">
      {{
        $t(`treatmentProgram.steam.step6.title`)
      }}
    </p>
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.brand"
          :label="$t('treatmentProgram.steam.step6.brand')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- Model -->
    <v-row class="xPadding">
      <v-col class="py-0">
        <VTextField
          v-model="data.model"
          :label="$t('treatmentProgram.steam.step6.model')"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <!-- functionalities -->
    <v-row class="xPadding">
      <v-col class="py-0">
        <VSelect
          v-model="data.functionalities.type"
          :label="$t('treatmentProgram.steam.step6.functionalities')"
          :items="functionalitiesType"
          itemValue="key"
          itemText="name"
          outlined
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="data.functionalities.type === 'other'"
      class="xPadding"
    >
      <v-col>
        <VTextField
          v-model="data.otherText"
          :label="$t('treatmentProgram.step1.other')"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { CONTROLLER_FUNCTIONALITIES_TYPE } from '@/constants/steamTreatmentPrograms';
import { cloneDeep } from 'lodash';

export default {
    name: 'TargetDosage',
    components: {
        VTextField,
    },
    props: {
        controller: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {
                functionalities: {},
            },
        };
    },
    computed: {
        functionalitiesType() {
            return CONTROLLER_FUNCTIONALITIES_TYPE.map(key => ({
                name: this.$t(`treatmentProgram.steam.step6.functionalitiesType.${key}`),
                key,
            }));
        },
    },
    watch: {
        controller: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.controller) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { controller: this.data });
        },
    },
};
</script>
    <style lang="scss" scoped>
    .xPadding{
      padding: 0 6rem;
    }
    @media screen and (max-width: 600px) {
       .xPadding{
          padding: 0;
        }
    }
    </style>
